import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';

export const platformList: listJson[] = [
  {
    id: 1,
    version_name: 'PC',
    checked: 0,
    rank: 0,
    tag_id: 0,
    tag_name: ''
  },
  {
    id: 2,
    version_name: 'Android',
    checked: 0,
    rank: 0,
    tag_id: 0,
    tag_name: ''
  },
  {
    id: 3,
    version_name: 'IOS',
    checked: 0,
    rank: 0,
    tag_id: 0,
    tag_name: ''
  }
];

export interface listJson {
  select?: any;
  id: string | number;
  version_name: string;
  checked: number;
  rank: number;
  tag_id: string | number;
  tag_name: string;
  name?: string;
  labelId?: string;
  labelName?: string;
}

export interface versionTagJson {
  tagList: listJson[];
  versionList: listJson[];
}

// 版本与标签接口
export function getTagVersionList() {
  return request<versionTagJson>({
    method: 'POST',
    url: httpApi.home.tagList
  });
}
